import React, { useEffect } from 'react';

import { Link } from 'react-scroll';

import useActiveSection from '@/hooks/useActiveSection';
import useIsAtTop from '@/hooks/useIsAtTop';

import { ListItemType } from './Sidemenu';

interface SideMenuLinksProps {
  items: ListItemType[];
}

export const SideMenuLinks = ({ items }: SideMenuLinksProps) => {
  const isAtTop = useIsAtTop();
  const { activeSection, setActiveSection } = useActiveSection(items);

  useEffect(() => {
    isAtTop && setActiveSection('');
  }, [isAtTop]);

  const menuItems = items.map(({ sectionId, title }) => (
    <li key={sectionId}>
      <Link
        to={sectionId}
        href={`#${sectionId}`}
        className={`subtitle-2 SideMenu_links-item ${activeSection === sectionId ? 'active' : ''}`}
        smooth
        offset={-30}
        duration={500}
      >
        {title}
      </Link>
    </li>
  ));

  return <ul className="SideMenu_links">{menuItems}</ul>;
};
